// important components
import initAnimations from './components/animations.js';
import swiperGalleries from './components/slider.js';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize animations
  initAnimations();

  // Initialize the loader function
  loader();

  // Initialize work filter
  initWorkFilter();

  // initialize swiper galleries
  swiperGalleries();
});

// global or one time use stuff
function loader() {
  // Main nav menu mobile
  const navMenu = document.querySelector('.nav-menu');
  document.querySelector('.mobile-menu').addEventListener('click', function () {
    this.classList.toggle('close-nav');
    navMenu.classList.toggle('open-nav');
  });

  let lightBoxContainer = document.querySelector('.lightbox-gallery');
  if (lightBoxContainer || document.querySelector('a[data-lightbox]')) {
    lightbox.option({
      resizeDuration: 200,
      wrapAround: true,
    });
  }
}

/**
 * Initialize work archive filter
 * Handles AJAX filtering of work posts by portfolio-categories
 */
function initWorkFilter() {
  const filterButtons = document.querySelectorAll('.work-filter-btn');
  const workGrid = document.getElementById('work-grid');
  const loadingIndicator = document.getElementById('work-loading');
  const emptyState = document.getElementById('work-empty');

  if (!filterButtons.length || !workGrid) {
    return; // Exit if elements don't exist (not on work archive page)
  }

  filterButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const termId = this.getAttribute('data-term-id');

      // Update active button state
      filterButtons.forEach((btn) => btn.classList.remove('active', '!border-bcolor-2'));
      filterButtons.forEach((btn) => btn.classList.remove('active', '!border-bcolor-2'));
      this.classList.add('active', '!border-bcolor-2');
      this.classList.remove('bg-gray-300', 'text-bcolor-2');

      // Show loading indicator and clear grid
      loadingIndicator.classList.remove('hidden');
      emptyState.classList.add('hidden');
      workGrid.innerHTML = '';
      workGrid.style.opacity = '0.5';

      // Make AJAX request
      jQuery.ajax({
        url: ll_ajax_object.ajaxurl,
        type: 'POST',
        data: {
          action: 'filter_work',
          nonce: ll_ajax_object.work_filter_nonce,
          term_id: termId,
        },
        success: function (response) {
          loadingIndicator.classList.add('hidden');
          workGrid.style.opacity = '1';

          if (response.success && response.data.length > 0) {
            // Build and insert post cards
            const html = response.data.map((post) => buildPostCard(post)).join('');
            workGrid.innerHTML = html;
          } else {
            // Show empty state
            emptyState.classList.remove('hidden');
            workGrid.innerHTML = '';
          }
        },
        error: function () {
          loadingIndicator.classList.add('hidden');
          workGrid.style.opacity = '1';
          workGrid.innerHTML = '<p class="text-red-500">Error loading posts. Please try again.</p>';
        },
      });
    });
  });
}

/**
 * Build HTML for a single work post card
 *
 * @param {Object} post - Post data object with id, title, permalink, featured_image, categories, attribution
 * @returns {string} HTML string for the post card
 */
function buildPostCard(post) {
  const imageHtml = post.featured_image
    ? `<div>
         <img src="${escapeHtml(post.featured_image)}" alt="${escapeHtml(post.title)}" class="work-grid-img" />
       </div>`
    : '';

  const categoriesHtml = post.categories.length > 0 ? `<p class="work-categories">${escapeHtml(post.categories.join(', '))}</p>` : '';

  const attributionHtml = post.attribution ? `<p class="work-attribution">${escapeHtml(post.attribution)}</p>` : '';

  return `
    <a href="${escapeHtml(post.permalink)}" class="work-post-card">
      ${imageHtml}
      <div class="work-details">
      ${categoriesHtml}
        <h2 class="work-title">
          ${escapeHtml(post.title)}
        </h2>
        ${attributionHtml}
      </div>
    </a>
  `;
}

/**
 * Escape HTML special characters to prevent XSS
 *
 * @param {string} text - Text to escape
 * @returns {string} Escaped text
 */
function escapeHtml(text) {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  };
  return text.replace(/[&<>"']/g, (m) => map[m]);
}
